import Icon from '../../../../common/icons/Icon.js'
import {getState, useSelector} from '../../../../store.js'
import {
  Count,
  Plural,
  PluralBlock,
} from '../../../../common/components/Plural.js'
import ProductFilter from '../../../../common/components/ProductFilter.js'
import ButtonLink from '../../../../common/components/Button/ButtonLink.js'
import ButtonPrimary from '../../../../common/components/Button/ButtonPrimary.js'
import ButtonSecondary from '../../../../common/components/Button/ButtonSecondary.js'
import {showConfirmMessageModal} from '../../../../common/components/Modal/ConfirmMessageModal.js'
import TextArea from '../../../../common/components/TextArea.js'
import {splitStr} from '../../../../common/string.js'

const formName = 'FILTER_PANEL__SKU'

async function showParseBulkSKUListModal({modalFormSelector, updateModalForm}) {
  await showConfirmMessageModal({
    title: 'Add Product SKUs',
    Message({form, updateModalForm}) {
      return (
        <div className="margin-top-10 margin-bottom-20">
          <p className="fs-00 lh-md margin-bottom-20">
            Enter product SKUs separated by spaces, line breaks, commas or tabs.
            Put quotes around SKUs if they contain spaces, line breaks, commas
            or tabs {`(example: "Red shirt XL" )`}.
          </p>

          <div className="w-75">
            <TextArea
              label="List of Product SKUs"
              id="sku_str_list"
              value={form.confirmValue}
              onChange={(confirmValue) => updateModalForm({confirmValue})}
              autoFocus
            />
          </div>
        </div>
      )
    },
    modalSize: 'sm',
    confirmText: 'Add SKUs',
    cancelText: 'Cancel',
    confirmValue: '',
    async onResolve({outcome}) {
      if (!outcome) {
        return
      }

      const {sku: existingSKUs} = modalFormSelector(getState())
      const newSKUs = splitStr(outcome)

      updateModalForm({sku: [...new Set([...existingSKUs, ...newSKUs])]})
    },
  })
}

export default function SKUFilterPanel({modalFormSelector, updateModalForm}) {
  const modalForm = useSelector(modalFormSelector)
  const skus = modalForm.sku
  const totalSelected = skus.length

  return (
    <div className="wrap--modal-filters wrap--modal-filters-skus">
      <div className="wrap__modal-subheader margin-bottom-25 flex--justify">
        <div>
          <div className="flex">
            <h4 className="fs-01 lh-sm uppercase margin-top-0 margin-bottom-0 flex--justify-col margin-right-10">
              <span>
                <strong>
                  SKU<span className="lowercase">s</span>
                </strong>
                {totalSelected > 0 && (
                  <PluralBlock count={totalSelected}>
                    <span className="lowercase text--blue margin-left-5">
                      (<Count /> <Plural word="SKU" p="s" /> added)
                    </span>
                  </PluralBlock>
                )}
              </span>
            </h4>
          </div>
          {totalSelected > 0 && (
            <div className="margin-top-7">
              <ButtonPrimary
                isOutlined
                size="x-sm"
                className="margin-right-5"
                onClick={() =>
                  showParseBulkSKUListModal({
                    modalFormSelector,
                    updateModalForm,
                  })
                }
              >
                Add a List of SKUs
              </ButtonPrimary>
              <ButtonSecondary
                size="x-sm"
                onClick={() => updateModalForm({sku: []})}
              >
                Clear All
              </ButtonSecondary>
            </div>
          )}
        </div>

        <div className="wrap--filter-search outer-wrap--product-search-100 w-35">
          <label
            className="label--input-prefix label--search"
            htmlFor="filters_tag_search"
          >
            <Icon name="search" className="icon--input-prefix" />
            <ProductFilter
              dropdown={`${formName}_PRODUCT_SEARCH`}
              excludedSKUs={skus}
              onSelect={(product) => {
                updateModalForm({sku: [...new Set([...skus, product.sku])]})
              }}
            />
          </label>
        </div>
      </div>
      {totalSelected > 0 ? (
        <ul className="list list--no-style list--modal-filters flex flex-wrap">
          {skus.map((sku, index) => {
            return (
              <li
                key={index}
                className="list__item list__item--modal-filters list__item--modal-filters-sku"
              >
                <span className="fs-00 lh-md margin-right-5">{sku}</span>
                <ButtonLink
                  onClick={() =>
                    updateModalForm({sku: skus.filter((s) => s !== sku)})
                  }
                >
                  <Icon name="times" />
                </ButtonLink>
              </li>
            )
          })}
        </ul>
      ) : (
        <div className="list__item--modal-filters-no-results padding-top-15">
          <p className="fs-01 lh-md margin-bottom-20">
            Filter down to orders containing specific SKUs by using the search
            bar.
          </p>
          <ButtonPrimary
            isOutlined
            size="sm"
            onClick={() =>
              showParseBulkSKUListModal({modalFormSelector, updateModalForm})
            }
          >
            Or Add a List of SKUs
          </ButtonPrimary>
        </div>
      )}
    </div>
  )
}
